export default {
    meta: {
        title: '鱼你在一起-审批结果'
    }
};
